export default __webpack_public_path__ + "static/media/server-sdk-icon.59fbab33.svg";